document.addEventListener("DOMContentLoaded", () => {


  function setViewedProducts() {
    //localStorage.removeItem('viewedProducts');
    let viewedFromStorage = JSON.parse(localStorage.getItem('viewedProducts')) || [];
    // console.log('viewedFromStorage', viewedFromStorage);
    
    // using mainProduct object
    let currentProduct = {
      name: mainProduct.title,
      type: mainProduct.type,
      url: window.location.pathname,
      image: mainProduct.featured_image,
      handle: mainProduct.handle,
      collections: mainProduct.collection_handles,
      usp_badges:mainProduct.metafields.usp_badges,
      custom_discount_message:mainProduct.metafields.custom_discount_message
    }

    const current_rating = document.querySelector('.product__info-wrapper .oke-sr-rating')
    current_rating ? currentProduct.star_rating = current_rating.textContent.trim() : currentProduct.star_rating = ''
    // console.info('currentProduct.star_rating:', currentProduct.star_rating)

    const addItem = () => {
      viewedFromStorage.unshift(currentProduct); // let's add it as the first item
      // var saveProductsLimit is from a setting in sections/main-product.liquid
      if (viewedFromStorage.length > saveProductsLimit) viewedFromStorage.pop();
      localStorage.setItem('viewedProducts', JSON.stringify(viewedFromStorage))
    }
    if (viewedFromStorage.length > 0) {
      const checkProductName = (item) => item.name === currentProduct.name;
      const viewedProductIndex = viewedFromStorage.findIndex(checkProductName)
      // console.log('viewedProductIndex:', viewedProductIndex)
      if (viewedProductIndex === -1) {
        addItem();
      };
    } else {
      addItem();
    }
  }
  
    //trying to give time for okendo to load
  setTimeout(setViewedProducts, 2000);
  
  // console.log('currentProduct', currentProduct);
  // console.log('viewedFromStorage', viewedFromStorage);
});